angular.module('ihestiaRestServicesBase')

/**
 * klauzule produktowe
 */
  .service('offerEditSvc', ['IHestiaRestServiceAbstractDef', function(IHestiaRestServiceAbstractDef) {

    /**
     * Główny konstruktor
     */
    var OfferEditSvc = function() {
      IHestiaRestServiceAbstractDef.apply(this, arguments);
      var self = this;
      this.resource = 'offer';
      this.businessArea = 'insurance';
      this.port = '8201';
      this.path = 'RestApplications';
      this.apiVersion = 'v2';

      /**
       * pobranie klauzul produktowych dla wniosku
       *
       * @param {String} id
       * @param {String} appMode
       * @param {String} offerId
       * @param {Object} data
       * @param {function} callback
       * @returns {*}
       */
      this.setOfferApk = function(offerId, apkDetails, callback, errorCallback, httpParams) {
        if(typeof httpParams === 'undefined' || httpParams === null)
        {
          httpParams = {};
        }

        httpParams.allowedStatuses = [403, 404, 409, 500];
        var data = {
          offerId: offerId,
          apkType: apkDetails.apkType
        };
        if (apkDetails.apkId) {
          data.apkId = apkDetails.apkId;
        }
        if (apkDetails.apkNumber) {
          data.apkNumber = apkDetails.apkNumber;
        }
        return self.post(null, data, 'saveApk', callback, errorCallback, httpParams);
      };

    };
    
    return new OfferEditSvc();
  }]);